export default {
    nl: {
        "account-checkup-done": "Je account is aangepast. Bedankt!",
        number: "getal",
        text: "tekst",

        domain: "onderzoeken-consumerhouse.be",

        "banner-title": "Marktonderzoeken bij ConsumerHouse",
        "banner-subtitle": "Bent u kritisch van aard? Of niet?",
        "banner-text":
            "Zin om een extraatje te verdienen? Schrijf u in voor al onze onderzoeken, geef uw mening en bepaal mee wat er in de rekken komt te liggen.",
        "banner-register": "Registreren",

        "error-answer-long": "Antwoord te lang.",

        "error-account-no-password":
            "Dit account staat in onze database, maar is niet geactiveerd. Voer een nieuw wachtwoord in om je account te activeren.",

        "error-login-required-email": "Gelieve een e-mailadres in te geven.",
        "error-login-invalid-email": "Ongeldig e-mailadres, voer het opnieuw in.",
        "error-login-required-password": "Geef een wachtwoord in.",
        "error-login-short-password": "Je wachtwoord moet minstens 7 karakters bevatten.",
        "error-login-long-password": "Je wachtwoord is te lang.",
        "error-login-wrong-password": "Fout wachtwoord. Probeer het opnieuw in te geven.",
        "error-login-wrong-email": "Er bestaat geen account met dit e-mailadres.",

        "error-register-required-firstname": "Gelieve een voornaam in te geven.",
        "error-register-long-firstname": "Voornaam is te lang.",
        "error-register-required-lastname": "Gelieve een achternaam in te geven.",
        "error-register-long-lastname": "Achternaam is te lang.",
        "error-register-required-email": "Gelieve een e-mailadres in te geven.",
        "error-register-invalid-email": "Ongeldig e-mailadres, voer het opnieuw in.",
        "error-register-required-gender": "Gelieve een geslacht te selecteren.",
        "error-register-required-birthdate": "Gelieve een geboortedatum in te geven.",
        "error-register-required-iban": "Gelieve een IBAN in te geven.",
        "error-register-invalid-iban": "Ongeldige IBAN, probeer het opnieuw in te geven.",
        "error-register-required-password": "Geef een wachtwoord in.",
        "error-register-short-password": "Je wachtwoord moet minstens 7 karakters bevatten.",
        "error-register-long-password": "Wachtwoord is te lang.",
        "error-register-required-howfound": "Geef in hoe je ons gevonden hebt.",
        "error-register-long-howfound": "Dit is te lang, gebruik niet meer dan een paar woorden.",
        "error-register-required-telephone": "Geef een telefoonnummer in.",
        "error-register-invalid-telephone": "Dit is een ongeldig telefoonnummer.",
        "error-register-exists-email":
            "Dit e-mailadres is al geregistreerd. Als je al een account hebt, kun je klikken op 'Ik heb al een account' aan de onderkant van de pagina.",
        "error-register-exists-iban":
            "Deze IBAN is al geregistreerd. Als je al een account hebt, kun je klikken op 'Ik heb al een account' aan de onderkant van de pagina.",

        "error-reset-password-nobody": "Geen gebruiker gevonden met deze informatie.",
        "error-reset-password-invalid-token":
            "Deze wachtwoord reset pagina is verlopen. Probeer je wachtwoord opnieuw te resetten via de login pagina.",

        "error-change-password-required-new": "Gelieve een nieuw wachtwoord in te geven.",
        "error-change-password-required-old": "Gelieve je oude wachtwoord in te geven.",
        "error-change-password-short-password": "Je wachtwoord moet minstens 7 karakters bevatten.",
        "error-change-password-long-password": "Wachtwoord is te lang.",

        "error-event-reserve-notfound": "Kon event niet vinden. Probeer het later nog eens.",
        "error-event-reserve-locationlimit": "Het gekozen tijdstip is volzet, kies een ander tijdstip.",
        "error-event-reserve-require-registration": "Je moet ingeschreven zijn voor het onderzoek voordat je kan meedoen.",
        "error-event-reserve-require-satisfies": "Je voldoet niet aan de criteria.",
        "error-event-reserve-twice":
            "Je bent al ingeschreven op een ander tijdstip voor deze test, je kan je inschrijving weergeven of uitschrijven via 'Mijn account'",
        "error-event-reserve-closed": "Deze test is gesloten.",

        "error-delete-account-limit": "Je hebt te veel geprobeerd.",
        "error-delete-account-wrong-password": "Fout wachtwoord.",

        "share-message": "Wil je iets bijverdienen? Kom producten testen bij ConsumerHouse!",
        "share-title": "Nodig vrienden uit en ontvang 5 euro per vriend!",

        "event-reserve-title": "Inschrijven voor",
        "event-reserve-test": "Deze test maakt onderdeel uit van het onderzoek ",
        "event-reserve-late-title": "Je bent te laat!",
        "event-reserve-late-description":
            " Er zijn geen tijdsvakken meer beschikbaar. Als dit een probleem is, of als dit niet klopt, neem dan contact op met ConsumerHouse.",
        "event-reserve-select-location": "Selecteer een locatie",
        "event-reserve-select-location-dropdown": "Kies...",
        "event-reserve-select-datetime": "Kies datum en tijdstip",
        "event-reserve-expect1": "Wij verwachten u op",
        "event-reserve-expect2": "om",
        "event-reserve-expect3": "op locatie",
        "event-reserve-expect4": "voor",
        "event-reserve-confirm": "Dit is correct, schrijf me in",
        "event-reserve-footnote": "Je kan op elk moment uitschrijven via 'Mijn account' en een nieuw tijdstip kiezen.",

        "reset-password": "Wachtwoord reset",
        "reset-password-limit": "Je hebt te veel geprobeerd, als je het echt niet weet kan je contact opnemen met ConsumerHouse.",
        "reset-password-info": "Geef de onderstaande informatie correct in om je wachtwoord opnieuw in te stellen.",
        "reset-password-email": "Je e-mail",
        "reset-password-iban": "Je IBAN",
        "reset-password-birthdate": "Je geboortedatum",
        "reset-password-newpassword": "Nieuw wachtwoord",
        "reset-password-cancel": "Annuleren",
        "reset-password-reset": "Wachtwoord opnieuw instellen",
        "reset-password-pending": "We hebben een e-mail gestuurd naar {email}, via deze mail kan je je wachtwoord opnieuw instellen.",

        "regions-welcome": "Welkom bij ConsumerHouse Onderzoeken",
        "regions-select": "Selecteer je regio",

        "change-password-old": "Oud wachtwoord",
        "change-password-new": "Nieuw wachtwoord",
        "change-password-finish": "Wijzigen",
        "change-password-cancel": "Annuleren",
        "change-password-limit": "Je kan nu je wachtwoord niet veranderen, probeer het later nog eens.",

        "edit-account": "Account aanpassen",
        "edit-account-notifications": "Meldingen",
        "edit-account-password-confirmation": "Geef je wachtwoord in om je aanpassingen te bevestigen.",
        "edit-account-email-exist": "Dit e-mailadres is al geregistreerd. Gebruik een ander e-mailadres of log in met het andere e-mailadres.",
        "edit-account-finish": "Opslaan",
        "edit-account-cancel": "Annuleren",

        register: "Registreren",
        "register-age-check": "Je bent {age} jaar oud.",
        "register-has-account": "Ik heb al een account",
        "register-select-date": "Kies datum",
        "register-firstname": "Voornaam",
        "register-lastname": "Achternaam",
        "register-language": "Voorkeurstaal",
        "register-email": "E-mail",
        "register-telephone": "Telefoonnummer",
        "register-birthdate": "Geboortedatum",
        "register-gender": "Geslacht",
        "register-iban": "IBAN",
        "register-password": "Wachtwoord",
        "register-password-noforget": "Vergeet je wachtwoord niet!",
        "register-howfound": "Hoe heeft u ons gevonden?",
        "register-faq": "Veelgestelde vragen",
        "register-faq-iban-title": "Waarom IBAN?",
        "register-faq-iban":
            "We gebruiken je IBAN om je geldbeloning naar je toe te sturen en om deels je identiteit te bewijzen. Voor de rest doen wij hier helemaal niks mee.",
        "register-terms-and-conditions": "Als je op registreren klikt, ga je akkoord met de algemene voorwaarden van ConsumerHouse.",
        "register-howfound-email": "Via e-mail",
        "register-howfound-friends": "Vrienden, familie, kennissen",
        "register-howfound-outside-ads": "Buitenreclame (affices, flyers ...)",
        "register-howfound-vehicle-ads": "Reclame op onze wagens",
        "register-howfound-instagram": "Instagram",
        "register-howfound-facebook": "Facebook",
        "register-howfound-social-media": "Andere sociale media",
        "register-howfound-ct": "ConsumerHouse Cycling Team",
        "register-howfound-other": "Iets anders",
        "register-howfound-student": "Studentenvereniging Socio",
        "register-howfound-student2": "Studentenvereniging Eligia",
        "register-howfound-student3": "Studentenvereniging KDA Kring der Alchemisten",
        "register-howfound-student4": "Studentenvereniging Nordkempus",
        "register-howfound-student5": "Studentenvereniging PSW Antwerpen",
        "register-howfound-student6": "Studentenvereniging Transfusia",
        "register-howfound-student7": "Studentenvereniging HSC brabo",
        "register-howfound-student8": "Scouts Rumoldus",
        "register-howfound-student9": "Scouts Boechout",
        "register-howfound-student10": "KSA Xaverius",
        "register-howfound-student11": "Xtra interim Wommelgem",
        "register-howfound-student12": "Asap Luik",
        "register-howfound-student13": "Chiro Woka",
        "register-howfound-student14": "Scouts Zandlopers Wechelderzande",
        "register-howfound-student15": "Jins Jonas II",
        "register-howfound-student16": "Scouts SMAF",
        "register-howfound-student17": "Chiro JAP",
        "register-howfound-student18": "Scouts 68",
        "register-howfound-student19": "Scouts Borsbeek",
        "register-howfound-student20": "KSA Xaverius ",
        "register-howfound-student21": "Scouts Xaverius",
        "register-howfound-student22": "Chiro Kiewit",
        "register-howfound-student23": "Scouts Wommelgem ",
        "register-howfound-student24": "Park Pirates",
        "register-howfound-student25": "Chiro Lille",
        "register-howfound-student26": "Chiro Kuringen",
        "register-howfound-student27": "Scouts Wijnegem",
        "register-howfound-student28": "Chiro Wijnegem",
        "register-howfound-student29": "Chiro WOKA",
        "register-howfound-student30": "Scouts Lille",
        "register-howfound-student31": "Scouts 30ste Prins Boudewijn",
        "register-howfound-student32": "JRK Kuringen",

        "register-gender-male": "Man",
        "register-gender-female": "Vrouw",
        "register-limit": "Je hebt te veel accounts aangemaakt in een korte tijd, probeer het later nog eens.",

        apply: "Inschrijven voor {name}",
        "apply-next-step": "Volgende stap",
        "apply-steps-title": "Hoe werkt een inschrijving?",
        "apply-step1": "Je vult een vragenlijst in.",
        "apply-step2": "Wij bekijken jouw antwoorden.",
        "apply-step3":
            "Als je geselecteerd word voor dit onderzoek, sturen we je een e-mail, anders sturen we je niks. Via deze e-mail kan je je inschrijving verder zetten.",
        "apply-step4": "Je doet mee aan het onderzoek.",
        "apply-step5": "Je krijgt je beloning toegestuurd.",
        "apply-next-step-finish": "Enquête bewaren",
        "apply-questions": "Vragenlijst",
        "apply-done-title": "Inschrijving opgenomen",
        "apply-done-info":
            "U ontvangt een e-mail als u geselecteerd wordt voor dit onderzoek. Via deze e-mail krijg je meer informatie over het verloop van dit onderzoek.",
        "apply-go-account": "Naar account",
        "apply-no-satisfies-age": "Je voldoet niet aan de leeftijds-criteria. Probeer een ander onderzoek.",
        "apply-test-closed": "Dit onderzoek is gesloten, je kan niet meer inschrijven.",
        "apply-unanswered-questions": "Vul eerst alle vragen in.",
        "apply-previous": "Vorige",
        "apply-next": "Volgende",
        "apply-unknown-test": "Het onderzoek is niet gevonden of je bent niet ingeschreven.",
        "apply-already-registered": "Je bent al ingeschreven voor dit onderzoek.",
        "apply-error": "Er is een fout opgetreden, probeer het later opnieuw.",
        "apply-require-login": "Voor je kan meedoen, moet je inloggen of een account aanmaken.",
        "apply-step-info": "Info",
        "apply-step-questions": "Vragenlijst",
        "apply-step-reserve": "Inschrijving",
        "apply-step-done": "Klaar",
        "apply-redirect": "Je wordt binnen enkele seconden doorgestuurd naar de onderzoeks-pagina.",

        "location-not-found": "Niks gevonden, probeer exacter te zijn.",

        "question-not-accepted": "Dit antwoord wordt niet aanvaard of is niet juist.",
        "question-already-filled": "Je hebt alle vragen al beantwoord, bedankt!",
        "question-multiple": "Je kan meerdere opties aanklikken.",
        "question-other": "Andere:",
        "question-optional": "Deze vraag moet NIET ingevuld worden.",
        "question-none": "Geen van bovenstaande",
        "question-none-table": "Geen",

        "app-running-tests": "Lopende onderzoeken",
        "app-new-test": "Nieuw onderzoek",
        "app-no-tests": "Er zijn momenteel geen testen aan de gang. Kom later terug.",
        "app-apply": "Inschrijven",
        "app-inform-telephone": "ConsumerHouse wilt je telefoonnummer weten, klik hieronder om dit in te stellen.",
        "app-set-telephone": "Telefoonnummer instellen",

        "nav-main": "Onderzoeken",
        "nav-welcome": "Welkom terug",
        "nav-menu-login": "Inloggen",
        "nav-menu-tests": "Onderzoeken",
        "nav-menu-my-account": "Mijn account",
        "nav-menu-logout": "Uitloggen",

        account: "Account",
        "account-logout": "Uitloggen",
        "account-edit-account": "Account aanpassen",
        "account-change-password": "Wachtwoord wijzigen",
        "account-enrolled": "Ingeschreven onderzoeken",
        "account-no-tests": "Als je je hebt opgegeven voor een onderzoek, komen ze hier tevoorschijn.",
        "account-no-tests-link": "Hier kan je onderzoeken vinden om aan mee te doen.",
        "account-reservations": "Afspraken",
        "account-reservations-info":
            "Dit zijn afspraken die je hebt ingepland. Zorg dat je aanwezig bent om je  beloning te kunnen claimen. Als je niet meer kan, kan je eerst uitschrijven en dan een nieuwe afspraak maken hierboven.",
        "account-pending-reservations": "Onderzoek testen",
        "account-pending-reservations-info":
            "Dit zijn testen waaraan je moet meedoen, maak zo snel mogelijk een afspraak. Deze testen hebben te maken met de onderzoeken waarvoor je je eerder hebt ingeschreven.",
        "account-pending-reservations-reserve": "Nu inschrijven",
        "account-reservation-cancel": "Uitschrijven",
        "account-reservation-cancel-confirm": "Ben je zeker dat je wilt uitschrijven voor",
        "account-reservation-expect1": "Je bent ingeschreven voor",
        "account-reservation-expect2": ", wij verwachten u",
        "account-reservation-expect3": "op",
        "account-reservation-expect4": "om",
        "account-reservation-expect5": "op locatie",
        "account-test-status-waiting": "U ontvangt een e-mail als u geselecteerd wordt voor dit onderzoek.",
        "account-test-status-done": "De beloning is naar je onderweg.",
        "account-test-status-running": "Je doet op dit moment mee met dit onderzoek.",
        "account-test-status-cancelled": "Je inschrijving of dit onderzoek is door jou of de leider geannuleerd.",
        "account-test-status-userCancelled": "Je inschrijving of dit onderzoek is door jou of de leider geannuleerd.",
        "account-test-status-noshow": "Je bent niet komen opdagen. Zorg dat je je inschrijving annuleert als je niet meer kan komen.",

        "account-friendinvites1": "Je hebt ",
        "account-friendinvites2": " vrienden uitgenodigd, waarvan er ",
        "account-friendinvites3": " een onderzoek voltooid hebben. Dit betekent dat je tot nu toe ",
        "account-friendinvites4": " euro verdiend hebt door vrienden uit te nodigen. (Het kan even duren tot het geld overgemaakt wordt.)",

        "account-test-cancel-confirm": "Ben je zeker dat je wilt uitschrijven voor '{test}'?",
        "account-test-cancel": "Uitschrijven",

        "delete-account": "Account verwijderen",
        "delete-account-info":
            "Geef je wachtwoord in om te bevestigen dat je je account wilt verwijderen. Al je inschrijvingen, antwoorden, reservaties, beloningen worden verwijderd. Je kan deze actie niet ongedaan maken.",
        "delete-account-password": "Wachtwoord",
        "delete-account-delete": "Verwijder account",
        "delete-account-cancel": "Annuleren",

        "registration-badge-waiting": "Wachten",
        "registration-badge-running": "Lopend",
        "registration-badge-done": "Beloond",
        "registration-badge-cancelled": "Admin geannuleerd",
        "registration-badge-userCancelled": "Gebruiker geannuleerd",
        "registration-badge-noshow": "Afwezig",

        "user-id": "Respondentennummer/ID",
        "user-name": "Naam",
        "user-email": "E-mail",
        "user-telephone": "Telefoonnummer",
        "user-iban": "IBAN",
        "user-birthdate": "Geboortedatum",
        "user-admin": "Admin",
        "user-gender": "Geslacht",
        "user-howfound": "Gevonden",

        "test-reward": "Beloning",
        "test-duration-prefix": "Duurtijd",
        "test-duration-suffix": "minuten",

        login: "Inloggen",
        "login-email": "E-mail",
        "login-password": "Wachtwoord",
        "login-limit": "Je hebt te veel geprobeerd, probeer het later nog eens.",
        "login-no-account": "Ik heb nog geen account",
        "login-secret": "geheim",
        "login-reset-password": "Wachtwoord vergeten",
        "email-preference": "E-mail voorkeuren",
        "email-preference-info": "Selecteer de gebeurtenissen waarvoor je een e-mail wilt ontvangen.",
        "email-preference-new-tests": "Nieuwe onderzoeken",
        "email-preference-notifications": "Herinneringen",
        "email-preference-save": "Opslaan",
        "email-preference-cancel": "Annuleren",

        "maintenance-mode": "De website is momenteel in onderhoud, kom later terug.",

        "cookie-info": "ConsumerHouse Onderzoeken maakt gebruikt van cookies. Door de website verder te gebruiken ga je akkoord met",
        "cookie-terms": "onze voorwaarden",
        "cookie-ok": "OK",

        "footer-select-region": "Andere regio...",
        "footer-contact": "ConsumerHouse Onderzoeken",
        "footer-account": "Account",
        "footer-account-change-password": "Wachtwoord veranderen",
        "footer-account-logout": "Uitloggen",
        "footer-account-delete": "Account verwijderen",
        "footer-account-my-tests": "Mijn onderzoeken",
        "footer-info-terms": "Algemene voorwaarden",
        "footer-gdpr": "GDPR",
        "footer-info": "Info",
        "footer-info-by": "Door",
        "footer-go-dutch": "Naar Nederlandse website",

        faq: "Veelgestelde vragen",
        "faq-no-answer": "Als de bovenstaande antwoorden niet jouw vraag beantwoorden, kan je een mailtje sturen naar support@consumerhouse.be.",

        "email-support": "Voor algemene vragen",
        "email-reward": "Voor vragen over incentives",
        "email-other": "Andere doeleinden",
    },
    fr: {
        domain: "etudes-consumerhouse.be",
        number: "numéro",
        text: "texte",

        "account-checkup-done": "Votre compte a été modifié. Merci!",

        "banner-title": "Études chez ConsumerHouse",
        "banner-subtitle": "Êtes-vous critique de nature? Ou pas?",
        "banner-text":
            "Voulez-vous arrondir vos fins de mois? Inscrivez-vous à toutes nos recherches, partagez avec nous votre opinion et ayez une influence sur les produits qui seront prochainement dans les rayons.",
        "banner-register": "S'inscrire",

        "error-answer-long": "Réponse trop longue.",

        "error-account-no-password":
            "Ce compte est dans notre base de données mais n'a pas été activé. Veuillez entrer un nouveau mot de passe pour activer votre compte.",

        "error-login-required-email": "Veuillez entrer une adresse électronique.",
        "error-login-invalid-email": "Adresse électronique invalide, saisissez-la à nouveau.",
        "error-login-required-password": "Entrez un mot de passe.",
        "error-login-short-password": "Votre mot de passe doit contenir au moins 7 caractères.",
        "error-login-long-password": "Votre mot de passe est trop long.",
        "error-login-wrong-password": "Erreur de mot de passe. Essayez d'y entrer à nouveau.",
        "error-login-wrong-email": "Il n'y a pas de compte avec cette adresse électronique.",

        "error-register-required-firstname": "Veuillez entrer un prénom.",
        "error-register-long-firstname": "Le prénom est trop long.",
        "error-register-required-lastname": "Veuillez entrer un nom de famille.",
        "error-register-long-lastname": "Le nom de famille est trop long.",
        "error-register-required-email": "Veuillez entrer une adresse électronique.",
        "error-register-invalid-email": "Adresse électronique invalide, saisissez-la à nouveau.",
        "error-register-required-gender": "Veuillez choisir un sexe.",
        "error-register-required-birthdate": "Veuillez entrer une date de naissance.",
        "error-register-required-iban": "Veuillez entrer un IBAN.",
        "error-register-invalid-iban": "IBAN non valide, essayez de le saisir à nouveau.",
        "error-register-required-password": "Entrez un mot de passe.",
        "error-register-short-password": "Votre mot de passe doit contenir au moins 7 caractères.",
        "error-register-long-password": "Votre mot de passe est trop long.",
        "error-register-required-howfound": "Entrez comment vous nous avez trouvés.",
        "error-register-long-howfound": "C'est trop long, n'utilisez pas plus que quelques mots.",
        "error-register-required-telephone": "Entrez un numéro de téléphone.",
        "error-register-invalid-telephone": "Il s'agit d'un numéro de téléphone non valide.",
        "error-register-exists-email":
            'Cette adresse électronique est déjà enregistrée. Si vous avez déjà un compte, vous pouvez cliquer sur "J\'ai déjà un compte" en bas de la page.',
        "error-register-exists-iban":
            'Cet IBAN est déjà enregistré. Si vous avez déjà un compte, vous pouvez cliquer sur "J\'ai déjà un compte" en bas de la page.',

        "error-reset-password-nobody": "Aucun utilisateur trouvé avec cette information.",
        "error-reset-password-invalid-token":
            "Cette page de réinitialisation du mot de passe a expiré. Veuillez essayer de réinitialiser votre mot de passe via la page de connexion.",

        "error-change-password-required-new": "Veuillez entrer un nouveau mot de passe.",
        "error-change-password-required-old": "Veuillez entrer votre ancien mot de passe.",
        "error-change-password-short-password": "Votre mot de passe doit contenir au moins 7 caractères.",
        "error-change-password-long-password": "Le mot de passe est trop long.",

        "error-event-reserve-notfound": "Impossible de trouver l'événement. Essayez de nouveau plus tard.",
        "error-event-reserve-locationlimit": "Le temps choisi est complet, choisissez un autre temps.",
        "error-event-reserve-require-registration": "Vous devez être inscrit à l'enquête avant de pouvoir y participer.",
        "error-event-reserve-require-satisfies": "Vous ne remplissez pas les critères.",
        "error-event-reserve-twice":
            'Vous êtes déjà inscrit à ce test, vous pouvez consulter votre inscription ou vous désinscrire via "Mon compte".',
        "error-event-reserve-closed": "Ce test est fermé",

        "error-delete-account-limit": "Vous avez trop essayé.",
        "error-delete-account-wrong-password": "Erreur de mot de passe.",

        "event-reserve-title": "S'inscrire pour",
        "event-reserve-test": "Ce test fait partie de l'étude ",
        "event-reserve-late-title": "Vous arrivez trop tard !",
        "event-reserve-late-description":
            "Il n'y a plus de créneaux horaires. S'il s'agit d'un problème, ou si cela n'est pas correct, veuillez contacter ConsumerHouse.",
        "event-reserve-select-location": "Sélectionnez un lieu",
        "event-reserve-select-location-dropdown": "Choisissez...",
        "event-reserve-select-datetime": "Choisissez la date et l'heure",
        "event-reserve-expect1": "Nous vous attendons à",
        "event-reserve-expect2": "à",
        "event-reserve-expect3": "sur place",
        "event-reserve-expect4": "pour",
        "event-reserve-confirm": "Inscrivez-moi",
        "event-reserve-footnote": 'Vous pouvez vous désinscrire à tout moment via "Mon compte" et choisir un nouveau moment.',

        "share-message": "Vous voulez gagner un peu d'argent supplémentaire? Venez tester les produits à la ConsumerHouse!",
        "share-title": "Invitez des amis et recevez 5 euros par ami.",

        "reset-password": "Réinitialisation du mot de passe",
        "reset-password-limit": "Vous avez trop essayé, si vous ne savez vraiment pas, vous pouvez contacter ConsumerHouse.",
        "reset-password-info": "Veuillez entrer correctement les informations ci-dessous pour réinitialiser votre mot de passe.",
        "reset-password-email": "Votre e-mail",
        "reset-password-iban": "Votre IBAN",
        "reset-password-birthdate": "Votre date de naissance",
        "reset-password-newpassword": "Nouveau mot de passe",
        "reset-password-cancel": "Annuler",
        "reset-password-reset": "Réinitialisation du mot de passe",
        "reset-password-pending": "Nous avons envoyé un courriel à {email}, par ce courriel vous pouvez réinitialiser votre mot de passe.",

        "regions-welcome": "Bienvenue dans les études de ConsumerHouse",
        "regions-select": "Sélectionnez votre région",

        "change-password-old": "Ancien mot de passe",
        "change-password-new": "Nouveau mot de passe",
        "change-password-finish": "Modifier",
        "change-password-cancel": "Annuler",
        "change-password-limit": "Vous ne pouvez pas changer votre mot de passe maintenant, réessayez plus tard.",

        "edit-account": "Modifier le compte",
        "edit-account-notifications": "Notifications",
        "edit-account-password-confirmation": "Entrez votre mot de passe pour confirmer vos modifications.",
        "edit-account-email-exist":
            "Cette adresse électronique est déjà enregistrée. Veuillez utiliser une autre adresse électronique ou vous connecter avec l'autre adresse électronique.",
        "edit-account-finish": "Sauvez",
        "edit-account-cancel": "Annuler",

        register: "S'inscrire",
        "register-age-check": "Vous avez {age} ans.",
        "register-has-account": "J'ai déjà un compte",
        "register-select-date": "Choisissez une date",
        "register-firstname": "Prénom",
        "register-lastname": "Nom de famille",
        "register-language": "Langue",
        "register-email": "E-mail",
        "register-telephone": "Numéro de téléphone",
        "register-birthdate": "Date de naissance",
        "register-gender": "Genre",
        "register-iban": "IBAN",
        "register-password": "Mot de passe",
        "register-password-noforget": "N'oubliez pas votre mot de passe!",
        "register-howfound": "Comment nous avez-vous trouvés?",
        "register-faq": "Foire aux questions",
        "register-faq-iban-title": "Pourquoi IBAN?",
        "register-faq-iban":
            "Nous utilisons votre IBAN pour vous envoyer votre récompense en espèces et pour prouver partiellement votre identité. Pour le reste, nous ne faisons rien avec ça.",
        "register-terms-and-conditions": "En cliquant sur s'inscrire, vous acceptez les conditions générales de ConsumerHouse.",
        "register-howfound-email": "Par e-mail",
        "register-howfound-friends": "Amis, famille, connaissances",
        "register-howfound-outside-ads": "Publicité extérieure (affiches, flyers ...)",
        "register-howfound-vehicle-ads": "Publicité sur nos voitures",
        "register-howfound-instagram": "Instagram",
        "register-howfound-facebook": "Facebook",
        "register-howfound-social-media": "Les médias sociaux",
        "register-howfound-ct": "ConsumerHouse Cycling Team",
        "register-howfound-other": "Autre",
        "register-howfound-student": "Association d'étudiants Socio",
        "register-howfound-student2": "Association d'étudiants Eligia",
        "register-howfound-student3": "Association d'étudiants KDA Kring der Alchemisten",
        "register-howfound-student4": "Association d'étudiants Nordkempus",
        "register-howfound-student5": "Association d'étudiants PSW Anvers",
        "register-howfound-student6": "Association d'étudiants Transfusia",
        "register-howfound-student7": "Association d'étudiants HSC brabo",
        "register-howfound-student8": "Scouts Rumoldus",
        "register-howfound-student9": "Scouts Boechout",
        "register-howfound-student10": "KSA Xaverius",
        "register-howfound-student11": "Xtra interim Wommelgem",
        "register-howfound-student12": "Asap Liège",
        "register-howfound-student13": "Chiro Woka",
        "register-howfound-student14": "Scouts Zandlopers Wechelderzande",
        "register-howfound-student15": "Jins Jonas II",
        "register-howfound-student16": "Scouts SMAF",
        "register-howfound-student17": "Chiro JAP",
        "register-howfound-student18": "Scouts 68",
        "register-howfound-student19": "Scouts Borsbeek",
        "register-howfound-student20": "KSA Xaverius ",
        "register-howfound-student21": "Scouts Xaverius",
        "register-howfound-student22": "Chiro Kiewit",
        "register-howfound-student23": "Scouts Wommelgem ",
        "register-howfound-student24": "Park Pirates",
        "register-howfound-student25": "Chiro Lille",
        "register-howfound-student26": "Chiro Kuringen",
        "register-howfound-student27": "Scouts Wijnegem",
        "register-howfound-student28": "Chiro Wijnegem",
        "register-howfound-student29": "Chiro WOKA",
        "register-howfound-student30": "Scouts Lille",
        "register-howfound-student31": "Scouts 30ste Prins Boudewijn",
        "register-howfound-student32": "JRK Kuringen",

        "register-gender-male": "Homme",
        "register-gender-female": "Femme",
        "register-limit": "Vous avez créé trop de comptes en peu de temps, réessayez plus tard.",

        apply: "S'inscrire pour {name}",
        "apply-next-step": "Prochaine étape",
        "apply-steps-title": "Comment fonctionne un enregistrement?",
        "apply-step1": "Vous remplissez un questionnaire.",
        "apply-step2": "Nous examinerons vos réponses.",
        "apply-step3":
            "Si vous êtes sélectionné pour cette enquête, nous vous enverrons un courriel, sinon nous ne vous enverrons rien. Grâce à cet e-mail, vous pouvez poursuivre votre inscription.",
        "apply-step4": "Vous participerez à l'enquête.",
        "apply-step5": "Votre récompense vous sera envoyée.",
        "apply-next-step-finish": "Enregistrement complet",
        "apply-questions": "Questionnaire",
        "apply-done-title": "Inscription incluse",
        "apply-done": "Vous faites la queue pour",
        "apply-done-info":
            "Vous recevrez un courrier électronique lorsque vous serez sélectionné pour cette enquête. Par ce courriel, vous recevrez plus d'informations sur le déroulement de cette recherche.",
        "apply-go-account": "Aller au compte",
        "apply-no-satisfies-age": "Vous ne remplissez pas les critères d'âge. Essayez une autre étude.",
        "apply-test-closed": "Cette enquête est close, vous ne pouvez pas vous enregistrer.",
        "apply-unanswered-questions": "Vous n'avez pas répondu à toutes les questions.",
        "apply-unanswered-questions": "Veuillez d'abord répondre à toutes les questions.",
        "apply-previous": "Précédent",
        "apply-next": "Suivant",
        "apply-unknown-test": "L'enquête n'a pas été trouvée ou vous n'étiez pas inscrit(e).",
        "apply-already-registered": "Vous êtes déjà inscrit pour cette enquête.",
        "apply-error": "Une erreur s'est produite, veuillez réessayer plus tard.",
        "apply-require-login": "Avant de pouvoir participer, vous devez vous connecter ou créer un compte.",
        "apply-step-info": "Info",
        "apply-step-questions": "Questionnaire",
        "apply-step-reserve": "Inscription",
        "apply-step-done": "Prêt",
        "apply-redirect": "Vous serez redirigé vers la page de recherche en quelques secondes.",

        "location-not-found": "Rien de trouvé, essayez d'être plus précis.",

        "question-not-accepted": "Cette réponse n'est pas acceptée ou est incorrecte.",
        "question-already-filled": "Vous avez déjà répondu à toutes les questions, merci!",
        "question-multiple": "Vous pouvez cliquer sur plusieurs options.",
        "question-other": "Autre:",
        "question-optional": "Cette question n'a PAS besoin d'être remplie.",
        "question-none": "Aucune de ces réponses",
        "question-none-table": "Non",

        "app-running-tests": "Enquêtes en cours",
        "app-new-test": "Nieuw onderzoek",
        "app-no-tests": "Aucun test n'est en cours pour le moment. Revenez plus tard.",
        "app-apply": "Inscrivez-vous",
        "app-inform-telephone": "ConsumerHouse souhaite connaître votre numéro de téléphone, cliquez ci-dessous pour le configurer.",
        "app-set-telephone": "Configuration du numéro de téléphone",

        "nav-main": "Études",
        "nav-welcome": "Bienvenue",
        "nav-menu-login": "Connexion",
        "nav-menu-tests": "L'études",
        "nav-menu-my-account": "Mon compte",
        "nav-menu-logout": "Déconnexion",

        account: "Compte",
        "account-logout": "Déconnexion",
        "account-edit-account": "Modifier le compte",
        "account-change-password": "Changement mot de passe",
        "account-enrolled": "Les examens enregistrés",
        "account-no-tests": "Si vous avez signé pour une enquête, ils vont se montrer ici.",
        "account-no-tests-link": "Vous trouverez ici les recherches auxquelles vous pouvez participer.",

        "account-reservations": "Nominations",
        "account-reservations-info":
            "Ce sont des rendez-vous que vous avez prévus. Assurez-vous que vous êtes présent pour réclamer votre récompense. Si vous n'en êtes plus capable, vous pouvez d'abord vous désabonner et ensuite prendre un nouveau rendez-vous ci-dessus.",
        "account-pending-reservations": "Recherche et essais",
        "account-pending-reservations-info":
            "Il s'agit de tests auxquels vous devez participer, prenez rendez-vous le plus tôt possible. Ces tests sont en rapport avec les tests auxquels vous vous êtes précédemment inscrit.",
        "account-pending-reservations-reserve": "S'inscrire",
        "account-reservation-cancel": "Se désabonner",
        "account-reservation-cancel-confirm": "Êtes-vous sûr de vouloir vous désabonner de",
        "account-reservation-expect1": "Vous êtes inscrit à",
        "account-reservation-expect2": ", nous vous attendons",
        "account-reservation-expect3": "dans",
        "account-reservation-expect4": "à",
        "account-reservation-expect5": "sur place",
        "account-test-cancel-confirm": "Vous êtes sûr de vouloir vous désabonner de '{test}'?",
        "account-test-cancel": "Se désabonner",

        "delete-account": "Supprimer le compte",
        "delete-account-info":
            "Entrez votre mot de passe pour confirmer que vous souhaitez supprimer votre compte. Toutes vos inscriptions, réponses, réservations, récompenses seront supprimées. Vous ne pouvez pas annuler cette action.",
        "delete-account-password": "Mot de passe",
        "delete-account-delete": "Supprimer le compte",
        "delete-account-cancel": "Annuler",

        "account-test-status-waiting": "Vous recevrez un courriel lorsque vous serez sélectionné pour cette enquête.",
        "account-test-status-done": "La récompense est en route vers vous.",
        "account-test-status-running": "Vous participez actuellement à l'enquête.",
        "account-test-status-cancelled": "L'enregistrement ou l'enquête a été annulé par vous ou par le responsable.",
        "account-test-status-userCancelled": "L'enregistrement ou l'enquête a été annulé par vous ou par le responsable.",
        "account-test-status-noshow": "Vous ne vous êtes pas présenté. Veillez à annuler votre inscription si vous ne pouvez pas venir.",

        "account-friendinvites1": "Vous avez invité ",
        "account-friendinvites2": " amis, dont ",
        "account-friendinvites3": " ont répondu à l'enquête. Cela signifie que vous avez gagné ",
        "account-friendinvites4": " jusqu'à présent en invitant des amis. (Le transfert de l'argent peut prendre un certain temps).",

        "registration-badge-waiting": "Attendre",
        "registration-badge-running": "Exécution",
        "registration-badge-done": "Récompensé",
        "registration-badge-cancelled": "Annulé",
        "registration-badge-userCancelled": "Annulé",
        "registration-badge-noshow": "Absent",

        "user-id": "Numéro du répondant/ID",
        "user-name": "Nom",
        "user-email": "E-mail",
        "user-telephone": "Téléphone",
        "user-iban": "IBAN",
        "user-birthdate": "Date de naissance",
        "user-admin": "Administrateur",
        "user-gender": "Genre",
        "user-howfound": "Trouvé",

        "test-reward": "Récompense",
        "test-duration-prefix": "Durée",
        "test-duration-suffix": "minutes",

        login: "Connexion",
        "login-email": "E-mail",
        "login-password": "Mot de passe",
        "login-limit": "Vous avez trop essayé, veuillez réessayer plus tard.",
        "login-no-account": "Je n'ai pas encore de compte",
        "login-secret": "secret",
        "login-reset-password": "Mot de passe oublié",

        "email-preference": "Préférences de courrier électronique",
        "email-preference-info": "Sélectionnez les événements pour lesquels vous souhaitez recevoir un courrier électronique.",
        "email-preference-new-tests": "Nouvelles enquêtes",
        "email-preference-notifications": "Rappels",
        "email-preference-save": "Save",
        "email-preference-cancel": "Annuler",

        "maintenance-mode": "Le site est actuellement en cours de maintenance, revenez plus tard.",

        "cookie-info": "ConsumerHouse Onderzoeken utilise des cookies. En continuant à utiliser le site web, vous acceptez de",
        "cookie-terms": "nos conditions",
        "cookie-ok": "OK",

        "footer-select-region": "Autre région...",
        "footer-contact": "ConsumerHouse Études",
        "footer-account": "Mon compte",
        "footer-account-change-password": "Changer le mot de passe",
        "footer-account-logout": "Déconnexion",
        "footer-account-delete": "Supprimer le compte",
        "footer-account-my-tests": "Mes recherches",
        "footer-info-terms": "Conditions générales",
        "footer-gdpr": "GDPR",
        "footer-info": "Info",
        "footer-info-by": "Par",
        "footer-go-dutch": "Le site web néerlandais",

        faq: "Questions fréquentes",
        "faq-no-answer": "Si les réponses ci-dessus ne répondent pas à votre question, vous pouvez envoyer un courriel à support@consumerhouse.be.",

        "email-support": "Questions générales",
        "email-reward": "Questions sur les incitations",
        "email-other": "Pour d'autres objectifs",
    },
};
